import React from "react";
import Header from "./Header/index.js";
import Footer from "./Footer/index.js";

export default function Layout({ children }) {
	return (
		<>
			<Header />
			<main>{children}</main>
			<Footer />
		</>
	);
}
